(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/choose/page.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/choose/page.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const useOrderHomeContext = svs.ticketsOrderHome.context.useOrderHomeContext;
const Envelope = svs.tur.Envelope;
const TicketOrderCounterWithPrice = svs.ticketsOrderHome.components.TicketOrderCounterWithPrice;
const CartBottomSheetContinue = svs.ticketsOrderHome.orderHome.components.CartBottomSheetContinue;
const trackOrderHomeCartSelections = svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeCartSelections;
const RECEIVER = svs.ticketsOrderHome.routes.ORDER_HOME.RECEIVER;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils,
  isMaximumQuantityWeightReachedForTicket = _svs$ticketsOrderHome.isMaximumQuantityWeightReachedForTicket,
  areTicketsOverweight = _svs$ticketsOrderHome.areTicketsOverweight;
const logger = svs.ticketsOrderHome.utils.logger;
const Body = _ref => {
  let ticket = _ref.ticket;
  const name = ticket.name,
    description = ticket.description,
    price = ticket.price;
  if (!name || !description || !price) {
    return null;
  }
  const productNameAndPrice = RegExp(/[0-9]{2,3}\b\skr\b/g).test(name.toLowerCase()) ? name : "".concat(name, " ").concat(price, " kr");
  return React.createElement("div", null, React.createElement("div", {
    className: "h2 f-content fw-500"
  }, productNameAndPrice), React.createElement("p", null, description));
};
setGlobal('svs.ticketsOrderHome.pages.Choose', _ref2 => {
  let history = _ref2.history;
  const _useOrderHomeContext = useOrderHomeContext(),
    state = _useOrderHomeContext.state,
    incrementOrderCount = _useOrderHomeContext.incrementOrderCount,
    decrementOrderCount = _useOrderHomeContext.decrementOrderCount,
    setOrderCount = _useOrderHomeContext.setOrderCount;
  const getCartTicket = id => {
    const cartTicket = state.cart.tickets.find(ticket => ticket.id === id);
    if (cartTicket) {
      return cartTicket;
    }
    return {
      count: 0,
      totalPrice: 0,
      incrementDisabled: isMaximumQuantityWeightReachedForTicket({
        id
      }, state.cart.tickets)
    };
  };

  useEffect(() => {
    const lotter = svs.utils.url.queryString.lotter;
    let href = svs.utils.url.updateQueryStringParameter(window.location.href, 'lotter', undefined);
    href = href.endsWith('?') ? href.slice(0, -1) : href;
    if (!lotter) {
      return;
    }
    if (state.tickets.every(ticket => ticket.count === 0)) {
      const preselectedTickets = lotter.split(',').map(ticket => ({
        id: ticket.split(':')[0],
        count: Number.parseInt(ticket.split(':')[1], 10)
      }));
      if (areTicketsOverweight(preselectedTickets)) {
        logger.warn('Preselected tickets exceed maximum quantity weight. Ignoring preselected tickets.');
        window.history.replaceState({}, document.title, href);
        return;
      }
      preselectedTickets.forEach(ticket => {
        setOrderCount(ticket.id, ticket.count);
      });
    }
    window.history.replaceState({}, document.title, href);
  }, []);
  const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.data.config.orderHome,
    orderHomeTitle = _svs$ticketsOrderHome2.orderHomeTitle,
    orderHomeSubtitle = _svs$ticketsOrderHome2.orderHomeSubtitle;
  const anyTicketReachesMaximumQuantity = state.availableTickets.some(ticket => getCartTicket(ticket.id).incrementDisabled);
  const onContinue = () => {
    trackOrderHomeCartSelections(state.cart.tickets);
    history.push(RECEIVER);
  };
  return React.createElement("div", {
    className: "order-home-choose-page"
  }, React.createElement("div", {
    className: "u-text-center f-body"
  }, React.createElement("h2", {
    className: "h2"
  }, orderHomeTitle), React.createElement("p", {
    className: "p order-home-choose-page-subtitle"
  }, orderHomeSubtitle)), React.createElement("div", {
    className: "tickets-order-home-envelopes"
  }, state.availableTickets.map(ticket => {
    const cartTicket = getCartTicket(ticket.id);
    const fullHeight = !anyTicketReachesMaximumQuantity || cartTicket.incrementDisabled;
    return React.createElement(Envelope, {
      branding: "triss",
      className: "u-flex u-flex-column envelope-order margin-top-1",
      image: ticket.image,
      key: ticket.id,
      repeatImage: Math.min(5, cartTicket.count)
    }, React.createElement("div", {
      className: "u-flex u-flex-column u-flex-justify-content-between padding-h-1 ".concat(fullHeight ? 'h100' : ''),
      "data-testid": "ticket-envelope-".concat(ticket.id)
    }, React.createElement(Body, {
      ticket: ticket
    }), React.createElement(TicketOrderCounterWithPrice, {
      count: cartTicket.count,
      incrementDisabled: cartTicket.incrementDisabled,
      onDecrement: () => decrementOrderCount(ticket.id),
      onIncrement: () => incrementOrderCount(ticket.id),
      totalPrice: cartTicket.totalPrice
    })));
  })), React.createElement(CartBottomSheetContinue, {
    onContinue: onContinue
  }));
});

 })(window);